(() => {
  // The app owns add/remove state; initialize only newly inserted custom buttons.
  const initialized = new WeakSet();
  const initialize = (root) => {
    const elements = [...(root.matches?.('.be-wishlist') ? [root] : []), ...root.querySelectorAll('.be-wishlist')];
    elements.forEach((element) => {
      if (element.closest('[data-be-search-top], [data-recent-products]') || initialized.has(element) || element.querySelector('button')) return;
      initialized.add(element);
      document.dispatchEvent(new CustomEvent('wishlist-hero-add-to-custom-element', { detail: element }));
    });
  };
  const start = () => {
    initialize(document);
    // Facets, pagination and recommendations replace DOM without a full navigation.
    new MutationObserver((records) => {
      records.forEach((record) => record.addedNodes.forEach((node) => {
        if (node.nodeType === 1) initialize(node);
      }));
    }).observe(document.querySelector('#MainContent') || document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
